import { render, staticRenderFns } from "./PerformanceTargetsTabExceptions.vue?vue&type=template&id=6edf3506"
import script from "./PerformanceTargetsTabExceptions.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetsTabExceptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports